import { useTranslation } from "react-i18next";
import { Form, Button, Card, Col, Row, message } from "../../ui/ot"
import { useEffect } from "react";
import { useCRUDController } from "../../ui/classify_structure/CRUDController";

const WeekCard = ({
    keyPrefix = "shift_management.week_overview",
    record = {},
    propsForm,
    propsExtraParams = {},
    propsParsedBody = {},
    propsApiRoute='/shift_management/api/week'
}) => {
    const { t } = useTranslation("translation", { keyPrefix });

    const [form_] = Form.useForm();
    const form = propsForm || form_;

    const onFormFinish = () => {
        const formValues = form.getFieldsValue();
        weekController.patchData([formValues])
    }

    const weekController = useCRUDController({
        apiRoute: propsApiRoute,
        onFinish: ({ axiosMode, status }) => {
            if (status === "success") {
                if (axiosMode === "post") {
                    message.success('新增成功')
                } else if (axiosMode === "patch") {
                    message.success('修改成功')
                }
            }
        }

    })

    useEffect(() => {
        form.setFieldsValue(record)
    }, [record])
    return <>
        <Form
            form={form}
            onFinish={onFormFinish}
        >
            <Card
                title={<>
                    <Row justify={'space-between'}>
                        <Col>
                            {t('week')}{record?.week_name}
                        </Col>
                        <Col>
                            <Row gutter={[16, 16]}>
                                <Col>
                                    <Button onClick={() => {
                                        const currentList = form.getFieldValue('class_week_data') || [];
                                        const newList = [...currentList, {
                                            ...propsExtraParams,
                                            ...propsParsedBody
                                        }]; // 加入一個空物件表示新項目
                                        form.setFieldsValue({ class_week_data: newList });

                                    }}>＋{t('post_class')}</Button>
                                </Col>
                                <Col>
                                    <Button onClick={() => form.trigger().then(response => {
                                        form.submit()
                                    })}>{t('save')}</Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </>}
                styles={{
                    backgroundColor: 'rgb(249, 250, 251)'
                }}
            >
                <Form.Item
                    name={'id'}
                    hidden
                ></Form.Item>
                <Form.List
                    name={'class_week_data'}
                >
                    {(fields, { add, remove }) => <>
                        {fields?.map(field => {
                            const value = form.getFieldValue(field?.name)
                            let show = true;
                            Object.keys(propsExtraParams)?.forEach(item => {
                                show = value?.[item]?.map(String)?.every((val, index) => val === propsExtraParams[item][index]);
                            })
                            return <>
                                <div style={{ padding: 16 }} hidden={!show}>
                                    <Card
                                        styles={{
                                            padding: 0
                                        }}
                                    >
                                        <Row justify={'space-between'}>
                                            <Col>
                                                <Row gutter={[16, 16]}
                                                    style={{
                                                        padding: 16
                                                    }}
                                                >
                                                    <Col style={{
                                                        alignItems: 'center',
                                                        padding: 0
                                                    }}>
                                                        <Form.Item
                                                            name={[field?.name, 'class_working_start_time']}
                                                        >
                                                            <input type={'time'} step="30" />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col style={{
                                                        alignItems: 'center'
                                                    }}>
                                                        至
                                                    </Col>
                                                    <Col style={{
                                                        alignItems: 'center',
                                                        padding: 0
                                                    }}>
                                                        <Form.Item
                                                            name={[field?.name, 'class_working_end_time']}
                                                        >
                                                            <input type={'time'} step="30" />
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col style={{
                                                alignSelf: 'center'
                                            }}>
                                                <button type="button" class="inline-flex items-center p-1 border border-transparent rounded-full text-red-600 hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500" aria-label="刪除星期一時段 08:00 至 22:00" onClick={() => remove(field?.id)}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x h-4 w-4" aria-hidden="true"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg></button>
                                            </Col>
                                        </Row>
                                    </Card>
                                </div>
                            </>
                        })}
                    </>}
                </Form.List>
            </Card >
        </Form >
    </>
}
export default WeekCard